import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { useTranslation } from "react-i18next";
import { BUTTON, MODAL_CONFIRM_TEXT } from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import { YuJaCheckbox } from "../standardization/YuJaCheckbox";

export default function RosterSyncConfirmModal({ config, content, setModalShow, show, AlertType = MODAL_CONFIRM_TEXT, handleclose = null,
    rosterCheckbox, setRosterCheckbox }) {
    const { t } = useTranslation();

    const [okBtnDisabled, setOkBtnDisabled] = useState(true);
    return (
        <Modal
            id="form-modal"
            show={show}
            onHide={!handleclose ? config.close : handleclose}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
        >
            <ModalClose tabIndex={0} aria-label={t("accessibility.closeModal")} role={BUTTON} onClick={handleclose ? handleclose : config.close} className="modal-close" />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {config.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div  style={{fontSize: 15, marginBottom: 20}}>{content}</div>
                {
                    config.checkBoxText &&
                    <YuJaCheckbox
                        label={config.checkBoxText}
                        checked={rosterCheckbox}
                        onChange={(checked) => {
                            if (checked) {
                                setRosterCheckbox(true);
                                setOkBtnDisabled(false);
                            } else {
                                setRosterCheckbox(false);
                                setOkBtnDisabled(true);
                            }
                        }}
                        style={{fontSize: 15, color: "#000000"}}
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton type="secondary" onClick={config.close}>
                    {config.cancelText ? config.cancelText : t("common.goBack")}
                </YuJaButton>
                <YuJaButton
                    onClick={(e) => {
                        e.preventDefault();
                        config.submit();
                    }}
                    type={AlertType === MODAL_CONFIRM_TEXT ? "primary" : "delete"}
                    disabled={okBtnDisabled}
                >
                    {config.okText}
                </YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}